import { useMemo } from 'react';

import { AiOutlineArrowUp } from '@react-icons/all-files/ai/AiOutlineArrowUp';
import { useScroll } from 'ahooks';

import { useScrollCacheContext } from '~/modules/reports/context/ScrollCacheProvider';

import { scrollToTopButton } from './styles.css';

export interface ScrollToTopProps {
  scrollCacheKey?: string;
  behavior?: ScrollBehavior;
}

export const ScrollToTop = (props: ScrollToTopProps) => {
  const { scrollCacheKey, behavior } = props;
  const { setScrollCache } = useScrollCacheContext();

  const scroll = useScroll(document);
  const isScrolled = (scroll?.top || 0) > 100;

  const toTop = () => {
    if (scrollCacheKey) {
      setScrollCache({
        [scrollCacheKey]: null,
      });
    }

    window.scrollTo({
      top: 0,
      left: 0,
      behavior,
    });
  };

  const translateY = useMemo(() => {
    if (!isScrolled) {
      return '4.25rem';
    }
    return '0';
  }, [isScrolled]);

  return (
    <button
      className={scrollToTopButton}
      style={{
        opacity: isScrolled ? 1 : 0,
        transform: `translateY(${translateY})`,
        transition: 'all 250ms ease',
      }}
      onClick={toTop}
    >
      <AiOutlineArrowUp fontSize={24} />
    </button>
  );
};
